export default function calculateCost(hours, hourlyRate) {
	return typeof hourlyRate === 'undefined' ? `$0` : (
		Number(hours) * Number(hourlyRate)
	).toLocaleString('en', {
		style: 'currency',
		currency: 'USD',
		maximumFractionDigits: 0,
	});
}